// ── Mega menús (iPhone / Mac / iPad) ──
(function () {
  'use strict';

  var backdrop = document.getElementById('mega-backdrop');
  var triggers = document.querySelectorAll('.mega-trigger');

  if (!triggers.length || !backdrop) return;

  var openInstance = null;

  function closeAllExcept(except) {
    triggers.forEach(function (trigger) {
      if (trigger === except) return;
      var menu = trigger.querySelector('.mega-menu');
      var label = trigger.querySelector('.mega-label');
      if (!menu) return;
      trigger.classList.remove('is-open');
      menu.classList.remove('is-visible');
      menu.setAttribute('aria-hidden', 'true');
      menu.inert = true;
      if (label) label.setAttribute('aria-expanded', 'false');
    });
  }

  function initInstance(trigger) {
    var menu  = trigger.querySelector('.mega-menu');
    var label = trigger.querySelector('.mega-label');
    if (!menu) return;

    var hoverTimer;
    var isOpen = false;

    function openMenu() {
      clearTimeout(hoverTimer);
      closeAllExcept(trigger);
      isOpen = true;
      openInstance = trigger;
      trigger.classList.add('is-open');
      menu.classList.add('is-visible');
      menu.setAttribute('aria-hidden', 'false');
      menu.inert = false;
      backdrop.classList.add('is-visible');
      if (label) label.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      isOpen = false;
      if (openInstance === trigger) openInstance = null;
      trigger.classList.remove('is-open');
      menu.classList.remove('is-visible');
      menu.setAttribute('aria-hidden', 'true');
      menu.inert = true;
      if (!openInstance) backdrop.classList.remove('is-visible');
      if (label) label.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose() {
      hoverTimer = setTimeout(closeMenu, 120);
    }

    // ── Hover ──
    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', scheduleClose);
    menu.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
    menu.addEventListener('mouseleave', scheduleClose);

    // ── Click (para touch y fallback) ──
    if (label) {
      label.addEventListener('click', function (e) {
        // Solo interceptar en desktop — dejar navegar en mobile
        if (window.innerWidth <= 900) return;
        e.preventDefault();
        isOpen ? closeMenu() : openMenu();
      });
    }

    trigger._closeMegaMenu = closeMenu;
  }

  triggers.forEach(initInstance);

  // ── Cerrar con backdrop ──
  backdrop.addEventListener('click', function () {
    closeAllExcept(null);
    openInstance = null;
    backdrop.classList.remove('is-visible');
  });

  // ── Cerrar con Escape ──
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openInstance) {
      closeAllExcept(null);
      openInstance = null;
      backdrop.classList.remove('is-visible');
    }
  });

  // ── Ajustar top de los mega menús según header height ──
  function syncMenuTop() {
    var header = document.getElementById('site-header');
    if (!header) return;
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      menu.style.top = header.offsetHeight + 'px';
    });
  }
  syncMenuTop();
  window.addEventListener('resize', syncMenuTop);

})();
